/* ----------
 Uniformsy: przenieś blok "model-info" (informacje o zdjęciach) pod galerię 
---------- */
(function () {
  function placeModelInfoAfterGrid() {
    var info = document.querySelector('.photo-info-block');
    var grid = document.querySelector('.product-details');
    if (!info || !grid) return;
    if (grid.nextElementSibling !== info) grid.insertAdjacentElement('afterend', info);
  }
  document.addEventListener('DOMContentLoaded', placeModelInfoAfterGrid);
  document.addEventListener('shopify:section:load', placeModelInfoAfterGrid);
})();